module.exports = __webpack_public_path__ + "images/category_lp/art_work/new/store_images/5_b0230b7c76409c8110781916023ddc44.png";